import projects from "./scripts/projects";
import addProject from "./scripts/addProject";
import projectImage from "./assets/img/project-img/background-gradient-generator.png"
import projectImage from "./assets/img/project-img/flashcards-study-application.png"
import projectImage from "./assets/img/project-img/flask-portfolio.png"
import projectImage from "./assets/img/project-img/guess-the-number.png"
import projectImage from "./assets/img/project-img/password-checker-haveibeenpwned.png"
import projectImage from "./assets/img/project-img/pokemon-breeding-compatibility-checker.png"
import projectImage from "./assets/img/project-img/pokemon-stat-calculator.png"
import projectImage from "./assets/img/project-img/robofriends.png"
import projectImage from "./assets/img/project-img/scrape-hacker-news-top-stories.png"
import projectImage from "./assets/img/project-img/smartbrain-face-detection.png"
import projectImage from "./assets/img/project-img/tenmo-money-transfers.png"
import projectImage from "./assets/img/project-img/uppercrust-pizza.png"
import projectImage from "./assets/img/project-img/virtual-vending-machine.png"
import projectImage from "./assets/img/project-img/website-layout-css-grid.png"

import email from "./scripts/email";
import addCopyEmailButtonListener from "./scripts/copyEmail";

import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";

projects.forEach((project) => addProject(project));
addCopyEmailButtonListener(email);

initScrollReveal(targetElements, defaultProps);
initTiltEffect();
